/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementButtonIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementButtonIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M6 3H7.5V7.00001L11 7C11.5523 7 12 7.44771 12 8V10.5858C12 10.851 11.8946 11.1054 11.7071 11.2929L10.2929 12.7071C10.1054 12.8946 9.851 13 9.58579 13L6.1894 13.0001L2.96973 9.78039L4.03039 8.71973L6 10.6893V3Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementButtonIcon.tags = [
  'button',
  'click',
  'pointer',
  'hand',
  'tap',
  'gesture',
];

ElementButtonIcon.category = 'Navigator';

ElementButtonIcon.iconSize = 16;
